import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faSearch,
    faSignOut,
    faBullhorn,
    faEye,
    faStore,
    faShoppingCart,
    faWallet,
    faCog,
    faUserFriends,
    faCreditCardBlank,
    faIdCard,
    faTimes,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faChevronDown,
    faBars,
    faQuestionCircle as regQuestionCircle,
    faHeart as regHeart,
    faCheck,
    faUniversity,
    faHandHoldingUsd,
    faTags as faTagsR,
    faScroll,
    faShieldAlt,
    faMapMarkerAlt as faMapMarkerAltR,
    faEngineWarning,
    faUserHeadset,
    faHomeAlt,
    faEllipsisH,
    faFilter,
    faListAlt,
    faArrowDown,
    faFileAlt,
} from "@fortawesome/pro-regular-svg-icons";

import { faQuestionCircle, faHeart, faShoppingBag, faBagsShopping, faMapMarkerAlt, faTags, faThumbsUp } from "@fortawesome/pro-light-svg-icons";

import {
    faHomeAlt as faHomeAltS,
    faMapMarkerCheck,
    faThumbsUp as faThumbsUpSolid,
    faChevronDown as faChevronDownSolid, 
    faChevronUp as faChevronUpSolid, 
    faPlusCircle,
    faMinusCircle,
    faCircle
} from "@fortawesome/pro-solid-svg-icons"

library.add(
    faPlusCircle,
    faMinusCircle,
    faArrowDown,
    faChevronDownSolid,
    faChevronUpSolid,
    faSearch,
    faSignOut,
    faBullhorn,
    faQuestionCircle,
    regQuestionCircle,
    faEye,
    faHeart,
    regHeart,
    faStore,
    faShoppingCart,
    faWallet,
    faCog,
    faUserFriends,
    faCreditCardBlank,
    faIdCard,
    faTimes,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faChevronDown,
    faBars,
    faShoppingBag,
    faBagsShopping,
    faMapMarkerAlt,
    faMapMarkerAltR,
    faCheck,
    faUniversity,
    faHandHoldingUsd,
    faTags,
    faTagsR,
    faScroll,
    faShieldAlt,
    faEngineWarning,
    faUserHeadset,
    faHomeAlt,
    faHomeAltS,
    faEllipsisH,
    faMapMarkerCheck,
    faThumbsUp,
    faThumbsUpSolid,
    faFilter,
    faListAlt,
    faFileAlt,
    faCircle
)